import { Outlet } from 'react-router'
import { observer } from 'mobx-react-lite'
import { ApplicationsViewProvider } from 'pages/settings/pages/developer/pages/applications/context/applicationsViewContext'

const ApplicationsPageLayoutContent = () => {
  return <Outlet />
}

export const ApplicationsPageLayout = observer(() => {
  return (
    <ApplicationsViewProvider>
      <ApplicationsPageLayoutContent />
    </ApplicationsViewProvider>
  )
})
